class BundleQuantityInput extends HTMLElement {
  constructor() {
    super()
    this.floatReg = /\d|\.\d/g
    this.moneyReg = /\w{3}$/gm
    this.currencyReg = /[$£RPpNT]/gm
    this.input = this.querySelector('input')
    this.variantPrice = this.input.getAttribute('data-price')
    this.changeEvent = new Event('change', { bubbles: true })

    this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper')
    this.errorMessage = ''
    this.errorEmpty = 'Quantity cannot be empty'

    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))

    if (this.input.value === '0') {
      console.log('0')
      this.input.value = '0'
    }
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
    console.log('change')
    if (this.input.getAttribute('name') !== 'quantity' && this.input.value > 0 && (event.target.name === '') | undefined) {
      this.setPrice('plus')
    }
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)

      // Hide error message of empty
      this.errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper')
      this.errorMessage = document.querySelector('.product-form__error-message').textContent
      if (this.errorMessage === this.errorEmpty) {
        this.errorMessageWrapper.setAttribute('hidden', '')
      }

      this.setPrice(event.target.name)
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)

    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }

  // PRICE INTEGRATION WITH QUANTITY
  setPrice(target) {
    const priceContainer = document.getElementById('price-product')

    const priceCaption = priceContainer.textContent
    const prevPrice = priceCaption.match(this.floatReg).join('')
    const typePrice = priceCaption.match(this.moneyReg).join('')
    const currencyPrice = priceCaption.match(this.currencyReg).join('')
    this.variantPrice = this.variantPrice.match(this.floatReg).join('')

    let currentPrice = parseFloat(prevPrice)

    if (target === 'plus') {
      currentPrice = (parseFloat(prevPrice) + parseFloat(this.variantPrice)).toFixed('2')
    } else {
      currentPrice = (parseFloat(prevPrice) - parseFloat(this.variantPrice)).toFixed('2')
    }

    priceContainer.innerHTML = currencyPrice + currentPrice + ' ' + typePrice
  }
}

customElements.define('bundle-quantity-input', BundleQuantityInput)
